import React, { useCallback } from 'react';
import { Category } from './types';
import * as S from './styles';

type Props = {
  category: Category;
  onClickCategoryLink: (id: string) => void;
};

const ThirdLevelCategory = ({ category, onClickCategoryLink }: Props) => {
  const { id, name } = category;

  const onClickCurrentCategoryLink = useCallback(
    () => onClickCategoryLink(id),
    [id, onClickCategoryLink]
  );

  return (
    <S.ThirdLevelItem key={id} title={name}>
      <S.ThirdLevelLink
        onClick={onClickCurrentCategoryLink}
        category={category}
      >
        {name}
      </S.ThirdLevelLink>
    </S.ThirdLevelItem>
  );
};

export default ThirdLevelCategory;
